import React from "react";
import { __ } from '@wordpress/i18n';
import MediaUploader from "../../../../components/media-uploader";
import { useStateValue } from '../../../../store/store';
import setSiteLogo from '../../../../components/media-uploader/utils';
import NextStepButton from '../../../../components/util/next-step-button/next-step-button';
import { Spacer } from '../../../../ui/style'

const BusinessLogoControls = (props) => {
	const { onNextClick, customizeStep } = props;
	const [{ siteLogo }] = useStateValue();

	return (
		<>
			<MediaUploader />

			{'' !== siteLogo.url ?
				<>
					<Spacer />
					<NextStepButton customizeStep={customizeStep} after onClick={(event) => {
						setSiteLogo(siteLogo);
						onNextClick();
					}}>{__('Proceed', 'astra-sites')}</NextStepButton>
				</> :
				''
			}
		</>
	);
};

export default BusinessLogoControls;
